import React from 'react';

import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
}));

export default function AuthLayout({ children }: React.PropsWithChildren<{}>) {
  const classes = useStyles();

  return (
    <>
      <CssBaseline />
      <div className={classes.root}>{children}</div>
    </>
  );
}
